import {
  Component,
  EventEmitter,
  input,
  Output,
  TemplateRef,
} from '@angular/core';
import { MatButtonColors, MatButtonType } from '../../models/z-button.model';

@Component({
  selector: 'z-button',
  templateUrl: './z-button.component.html',
  styleUrls: ['./z-button.component.scss'],
})
export class ZButtonComponent {
  readonly MatButtonType = MatButtonType;
  readonly MatButtonColors = MatButtonColors;
  readonly id = input<string>();
  readonly icon = input<string>();
  readonly color = input<'primary' | 'secondary' | 'accent' | 'warn'>(
    MatButtonColors.PRIMARY
  );
  readonly label = input<string>();
  readonly matType = input<'flat' | 'raised' | 'stroked' | 'menu'>(
    MatButtonType.FLAT
  );
  readonly customLabel = input<TemplateRef<unknown>>();
  readonly routerLink = input<string>();
  readonly outline = input<boolean>();
  readonly disabled = input<boolean>();
  readonly buttonType = input<string>('button');
  readonly queryParams = input<unknown>();

  @Output()
  clicked: EventEmitter<unknown> = new EventEmitter();

  emitClick(event): void {
    if (this.disabled()) {
      return;
    }
    this.clicked.emit(event);
  }
}
